<template>
  <footer class="footer">
    <div class="footer-inner">
      <nav class="footer-links">
        <router-link to="/about">About</router-link>
        <router-link to="/terms-of-service">Terms</router-link>
        <a :href="API_Docs_URL" target="_blank" rel="noopener">API</a>
        <a href="https://status.linker.to" target="_blank" rel="noopener">Status</a>
      </nav>

      <div class="footer-meta">
        <span class="footer-tagline">Made with ❤️ in San Francisco · a <a href="https://stellalabs.llc/" target="_blank" rel="noopener">Stella Labs</a> project</span>
        <div class="footer-right">
          <span class="version-info mono">
            UI {{ commitHash ? commitHash.slice(0, 7) : 'dev' }}
            <span v-if="apiVersion || apiError" class="sep">·</span>
            <template v-if="apiVersion || apiError">
              API {{ apiVersion || 'unknown' }}<span v-if="apiError" class="api-warn"> (unreachable)</span>
            </template>
          </span>
          <ThemeToggle />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {config} from '@/runtimeConfig';
import ThemeToggle from '@/components/ui/ThemeToggle.vue';

export default {
  name: 'AppFooter',
  components: {ThemeToggle},
  data() {
    return {
      commitHash: process.env.VUE_APP_COMMIT_HASH || null,
      apiVersion: '',
      apiError: false
    }
  },
  computed: {
    API_Docs_URL() {
      return config.backendBaseUrl + 'docs/';
    },
  },
  async mounted() {
    try {
      // Parse the base URL from the API URL by removing /api/v1/
      const apiUrl = config.backendBaseUrl
      const baseUrl = apiUrl ? apiUrl.replace(/\/api\/v1\/$/, '') : `${window.location.protocol}//${window.location.hostname}`
      
      const response = await fetch(baseUrl)
      if (!response.ok) throw new Error('API request failed')
      
      const data = await response.json()
      this.apiVersion = data.commit ? data.commit.substring(0, 7) : data.v
    } catch (err) {
      console.warn('Could not fetch API version:', err)
      this.apiError = true
    }
  }
}
</script>

<style scoped>
.footer {
  border-top: 1px solid var(--border);
  padding: 18px clamp(16px, 4vw, 40px);
  background: var(--bg);
}
.footer-inner {
  max-width: 1080px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.footer-links {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.footer-links a {
  font-size: 13px;
  font-weight: 500;
  color: var(--muted);
  text-decoration: none;
}
.footer-links a:hover { color: var(--text); }
.footer-links a.router-link-active { color: var(--text); }

.footer-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}
.footer-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.footer-tagline {
  font-size: 12.5px;
  color: var(--muted);
  font-weight: 500;
}
.footer-tagline a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 600;
}
.footer-tagline a:hover { text-decoration: underline; }
.version-info {
  font-size: 12px;
  color: var(--faint);
}
.sep { margin: 0 4px; opacity: .6; }
.api-warn { color: var(--warn); }
</style>
